import {apiURl} from './apiconfig'

const register = (user, token) => {
    const REGISTER_API_ENDPOINT = apiURl + 'users/register';
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization' : 'Bearer ' + token,
      },
      body: JSON.stringify(user)
    };

    return fetch(REGISTER_API_ENDPOINT, parameters)
    .then(response => {
        const statusCode = response.status;
        const data = response.json();

        return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
        return [res, data];
    })
    .catch(error => {
        return error;
    });
};

export {
    register
}